<template>
  <div class="container-fluid">
    <div id="brs" class="contents">
      <section class="adv mt-0">
        <!-- <h6 class="sub-title">피팅 광고</h6> -->
        <div class="row g-0">
          <div class="col-sm-5 col-md-4">
            <div
              class="col adv-item adv-video"
              :class="{
                'has-item': fittingreqinfo.fit_ad_no_mov,
              }"
            >
              <video
                class="ratio"
                controls
                autoplay
                muted
                v-if="fittingreqinfo.adinfo.ad_mov_info.fit_ad_mov"
              >
                <source
                  v-if="fittingreqinfo.adinfo.ad_mov_info.fit_ad_mov"
                  type="video/mp4"
                  :src="fittingreqinfo.adinfo.ad_mov_info.fit_ad_mov | get_img"
                />
                {{
                  $t(
                    "text.brandroom.your_browser_does_not_support_the_video_tag"
                  )
                }}
              </video>
            </div>
          </div>
          <div class="col-sm-7 col-md-8 flex-wrap">
            <div
              class="col-12 adv-item adv-title justify-content-center mb-2"
              :class="{ 'has-item': fittingreqinfo.fit_ad_no_title }"
            >
              <img
                v-if="fittingreqinfo.fit_ad_no_title"
                class="img-fluid align-self-center py-2 py-sm-4 bg-white"
                :src="fittingreqinfo.adinfo.ad_title_info.fit_ad_img | get_img"
              />
            </div>
            <div class="row g-0 flex-grow-1">
              <div
                class="col adv-item adv-goods flex-sm-wrap"
                :class="{ 'has-item': fittingreqinfo.fit_ad_no_img1 }"
              >
                <img
                  v-if="fittingreqinfo.fit_ad_no_img1"
                  :src="fittingreqinfo.adinfo.ad_img1_info.fit_ad_img | get_img"
                />
                <p class="goods-name" v-if="fittingreqinfo.fit_ad_no_img1">
                  <span>{{
                    fittingreqinfo.adinfo.ad_img1_info.fit_ad_title
                  }}</span>
                </p>
              </div>

              <div
                class="col adv-item adv-goods mx-0 mx-sm-2 flex-sm-wrap"
                :class="{ 'has-item': fittingreqinfo.fit_ad_no_img2 }"
              >
                <img
                  v-if="fittingreqinfo.fit_ad_no_img2"
                  :src="fittingreqinfo.adinfo.ad_img2_info.fit_ad_img | get_img"
                />
                <p class="goods-name" v-if="fittingreqinfo.fit_ad_no_img2">
                  <span>{{
                    fittingreqinfo.adinfo.ad_img2_info.fit_ad_title
                  }}</span>
                </p>
              </div>
              <div
                class="col adv-item adv-goods flex-sm-wrap"
                :class="{ 'has-item': fittingreqinfo.fit_ad_no_img3 }"
              >
                <img
                  v-if="fittingreqinfo.fit_ad_no_img3"
                  :src="fittingreqinfo.adinfo.ad_img3_info.fit_ad_img | get_img"
                />
                <p class="goods-name" v-if="fittingreqinfo.fit_ad_no_img3">
                  <span>{{
                    fittingreqinfo.adinfo.ad_img3_info.fit_ad_title
                  }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- //광고등록 -->
      <section>
        <h6 class="sub-title">{{ $t("title.brandroom.buyer_infromation") }}</h6>
        <div
          class="row g-0 row-cols-2 row-cols-md-4 row-cols-lg-6- table-type header-col"
        >
          <div
            class="col col-lg-1 justify-content-center px-0 border-bottom border-lg-0"
          >
            {{ $t("title.common.nickname") }}
          </div>
          <div class="col border-bottom border-lg-0 align-self-center">
            <MemberInfo
              :nickname="fittingreqinfo.memberinfo.membername"
              :playerno="fittingreqinfo.memberinfo.memberno"
            />
            <!-- <span class="material-icons-outlined ms-1 fs-6">help_outline</span> -->
          </div>
          <div
            class="col col-lg-1 justify-content-center px-0 border-bottom border-lg-0"
          >
            {{ $t("title.common.orderdate") }}
          </div>
          <div class="col border-bottom border-lg-0 align-self-center">
            <span class="text-date">
              {{ fittingreqinfo.memberinfo.orderdate || "-" }}
            </span>
          </div>
          <div class="col col-lg-1 justify-content-center px-0 border-bottom-0">
            {{ $t("title.common.location") }}
          </div>
          <div class="col-md-9 col-lg align-self-center">
            <span class="shop-name">{{
              fittingreqinfo.memberinfo.shopname
            }}</span>
          </div>
        </div>
      </section>
      <div class="tab-sub mt-4">
        <swiper
          :options="{
            slidesPerView: 'auto',
            freeMode: true,
            loop: false,
            initialSlide: preViewTabIndex,
          }"
        >
          <swiper-slide
            :class="{
              active: preViewTabIndex == 0,
            }"
          >
            <div @click="preViewTabIndex = 0">
              {{ $t("title.brandroom.fitting_report") }}
            </div>
          </swiper-slide>
          <swiper-slide :class="{ active: preViewTabIndex == 1 }">
            <div @click="preViewTabIndex = 1">
              {{ $t("title.brandroom.one_point_lesson") }}
            </div>
          </swiper-slide>
          <swiper-slide :class="{ active: preViewTabIndex == 2 }">
            <div @click="preViewTabIndex = 2">
              {{ $t("title.brandroom.permium") }}
            </div>
          </swiper-slide>
          <swiper-slide :class="{ active: preViewTabIndex == 3 }">
            <div @click="preViewTabIndex = 3">
              {{ $t("title.brandroom.entry") }}
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <!-- //tab-sub -->

      <div class="tab-content" id="pills-tabContent">
        <!-- TabIndex : 0, 피팅리포트 -->
        <div
          class="tab-pane fade show"
          :class="{ active: preViewTabIndex == 0 }"
        >
          <section>
            <h6 class="sub-title">
              {{ $t("title.brandroom.fitting_total_analysis") }}
            </h6>
            <div class="row g-0 table-type header-col">
              <div class="col-sm-5 col-md-4">
                <span>{{ $t("title.brandroom.fitting_analysis") }}</span>
              </div>
              <div class="col-sm-7 col-md-8">
                <textarea
                  class="form-control"
                  v-model="fittingreqinfo.fit_ans_txt"
                  readonly
                ></textarea>
              </div>
              <div class="col-sm-5 col-md-4 border-sm-0">
                <span>{{ $t("title.brandroom.attachment") }}</span>
              </div>
              <div class="col-sm-7 col-md-8">
                <span v-if="fittingreqinfo.fit_ans_file">
                  <span>{{ fittingreqinfo.fit_ans_file }}</span>
                </span>
              </div>
            </div>
          </section>
          <!-- //피팅 종합 분석 -->

          <section class="fitting-anls">
            <h6 class="sub-title">
              {{ $t("title.brandroom.structuralandclubanalysis") }}
              <mark class="font-monospace text-orange"
                >{{ $t("title.brandroom.par_left")
                }}{{ fittingreqinfo.fit_club_type | get_club_type }}
                {{ $t("title.brandroom.standard_par_right") }}</mark
              >
            </h6>
            <div class="card-group">
              <div class="row g-3 flex-fill">
                <!-- 공통 : 구질분석 -->
                <div class="col-md-4">
                  <div class="card h-100">
                    <div class="card-body">
                      <Radar
                        class="pitch-anls"
                        :chart-data="resultradardata"
                        :chart-options="radaroptions"
                      />
                    </div>
                    <!-- //card-body -->
                    <div
                      class="card-footer bg-white px-0 px-md-2 py-4 rounded-0 border-top border-bottom-gray border-bottom-md-0"
                    >
                      <div class="row gx-2 gy-2 text-nowrap fs-14">
                        <div class="col">
                          <div class="d-flex flex-column">
                            <p class="mb-2">
                              <small class="rounded-circle bg-green">1</small
                              >{{ $t("title.brandroom.distance") }}
                            </p>
                            <input
                              type="text"
                              class="text-truncate"
                              aria-label="거리 평가"
                              :value="fittingreqinfo.grade_distance"
                              readonly
                            />
                          </div>
                        </div>
                        <div class="col">
                          <div class="d-flex flex-column">
                            <p class="mb-2">
                              <small class="rounded-circle bg-orange">2</small
                              >{{ $t("title.brandroom.direction") }}
                            </p>
                            <input
                              type="text"
                              class="text-truncate"
                              aria-label="방향성 평가"
                              v-model="fittingreqinfo.grade_direction"
                              readonly
                            />
                          </div>
                        </div>
                        <div class="col">
                          <div class="d-flex flex-column">
                            <p class="mb-2">
                              <small class="rounded-circle bg-pink">3</small
                              >{{ $t("title.brandroom.accuracy") }}
                            </p>
                            <input
                              type="text"
                              class="text-truncate"
                              aria-label="정확도 평가"
                              v-model="fittingreqinfo.grade_accuracy"
                              readonly
                            />
                          </div>
                        </div>
                        <div class="col">
                          <div class="d-flex flex-column">
                            <p class="mb-2">
                              <small class="rounded-circle bg-purple">4</small
                              >{{ $t("title.brandroom.posture") }}
                            </p>
                            <input
                              type="text"
                              class="text-truncate"
                              aria-label="자세 평가"
                              v-model="fittingreqinfo.grade_position"
                              readonly
                            />
                          </div>
                        </div>
                        <div class="col">
                          <div class="d-flex flex-column">
                            <p class="mb-2">
                              <small class="rounded-circle bg-blue">5</small
                              >{{ $t("title.brandroom.Impact") }}
                            </p>
                            <input
                              type="text"
                              class="text-truncate"
                              aria-label="임팩트 평가"
                              v-model="fittingreqinfo.grade_impact"
                              readonly
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- //card-footer -->
                  </div>
                </div>
                <!-- //공통 : 구질분석 -->
                <!-- 클럽분석 : 드라이버, 우드, 유틸 -->
                <div
                  class="col-md-4 border-end-md border-start-md"
                  v-if="fittingreqinfo.fit_club_type < 4"
                >
                  <div class="card h-100">
                    <div class="card-body d-flex justify-content-center p-0">
                      <img
                        src="/img/fit_anls_dvr_tv.png"
                        class="align-self-center img-fluid"
                        alt="클럽분석"
                      />
                    </div>
                    <!-- //card-body -->
                    <div
                      class="card-footer bg-white px-0 px-md-2 py-4 rounded-0 border-top border-bottom-gray border-bottom-md-0"
                    >
                      <div class="row gx-2 gy-2 text-nowrap fs-14">
                        <div class="col">
                          <div class="d-flex flex-column">
                            <p class="mb-2">
                              <small class="rounded-circle bg-green">1</small
                              >{{ $t("title.brandroom.headvolume") }}
                            </p>
                            <p class="d-flex align-items-center">
                              <input
                                type="text"
                                class="text-truncate"
                                id="head-volume"
                                :placeholder="$t('title.brandroom.headvolume')"
                                :aria-label="
                                  $t('title.brandroom.input_headvolume')
                                "
                                v-model="fittingreqinfo.club_headvolume"
                                readonly
                              />
                              <label for="head-volume" class="ms-1">㎤</label>
                            </p>
                          </div>
                        </div>
                        <div class="col">
                          <div class="d-flex flex-column">
                            <p class="mb-2">
                              <small class="rounded-circle bg-orange">2</small
                              >{{ $t("title.brandroom.loft") }}
                            </p>
                            <p class="d-flex align-items-center">
                              <input
                                type="text"
                                class="text-truncate"
                                id="loft"
                                :placeholder="$t('title.brandroom.loft')"
                                :aria-label="$t('title.brandroom.input_loft')"
                                v-model="fittingreqinfo.club_loft"
                                readonly
                              />
                              <label for="loft" class="ms-1">&deg;</label>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- //card-footer -->
                  </div>
                </div>

                <div class="col-md-4" v-if="fittingreqinfo.fit_club_type < 4">
                  <div class="card h-100">
                    <div class="card-body d-flex justify-content-center p-0">
                      <img
                        src="/img/fit_anls_dvr_fv.png"
                        class="align-self-center img-fluid"
                        alt="클럽분석"
                      />
                    </div>
                    <!-- //card-body -->
                    <div
                      class="card-footer bg-white px-0 px-md-2 py-4 rounded-0 border-top"
                    >
                      <div class="row gx-2 gy-2 text-nowrap fs-14">
                        <div class="col">
                          <div class="d-flex flex-column">
                            <p class="mb-2">
                              <small class="rounded-circle bg-green">1</small
                              >{{ $t("title.brandroom.lie") }}
                            </p>
                            <p class="d-flex align-items-center">
                              <input
                                type="text"
                                class="text-truncate"
                                id="lie"
                                :placeholder="$t('title.brandroom.lie')"
                                :aria-label="$t('title.brandroom.input_lie')"
                                v-model="fittingreqinfo.club_lie"
                                readonly
                              />
                              <label for="lie" class="ms-1">&deg;</label>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- //card-footer -->
                  </div>
                </div>
                <!-- //클럽분석 : 드라이버, 우드, 유틸 -->

                <!-- 클럽분석 : 아이언, 웨지 -->
                <div
                  class="col-md-4 border-end-md border-start-md"
                  v-if="fittingreqinfo.fit_club_type > 3"
                >
                  <div class="card h-100">
                    <div class="card-body d-flex justify-content-center p-0">
                      <img
                        src="/img/fit_anls_iron_tv.png"
                        class="align-self-center img-fluid"
                        alt="클럽분석"
                      />
                    </div>
                    <!-- //card-body -->
                    <div
                      class="card-footer bg-white px-0 px-md-2 py-4 rounded-0 border-top border-bottom-gray border-bottom-md-0"
                    >
                      <div class="row gx-2 gy-2 text-nowrap fs-14">
                        <div class="col">
                          <div class="d-flex flex-column">
                            <p class="mb-2">
                              <small class="rounded-circle bg-green">1</small
                              >{{ $t("title.brandroom.bounce") }}
                            </p>
                            <p class="d-flex align-items-center">
                              <input
                                type="text"
                                class="text-truncate"
                                id="bounce"
                                :placeholder="$t('title.brandroom.bounce')"
                                :aria-label="$t('title.brandroom.input_bounce')"
                                v-model="fittingreqinfo.club_bounce"
                                readonly
                              />
                              <label for="bounce" class="ms-1">&deg;</label>
                            </p>
                          </div>
                        </div>
                        <div class="col">
                          <div class="d-flex flex-column">
                            <p class="mb-2">
                              <small class="rounded-circle bg-orange">2</small
                              >{{ $t("title.brandroom.fp") }}
                            </p>
                            <p class="d-flex align-items-center">
                              <input
                                type="text"
                                class="text-truncate"
                                id="FP"
                                :placeholder="$t('title.brandroom.fp')"
                                :aria-label="$t('title.brandroom.input_fp')"
                                v-model="fittingreqinfo.club_fp"
                                readonly
                              />
                              <label for="FP" class="ms-1">{{
                                $t("title.common.㎜")
                              }}</label>
                            </p>
                          </div>
                        </div>
                        <div class="col">
                          <div class="d-flex flex-column">
                            <p class="mb-2">
                              <small class="rounded-circle bg-pink">3</small
                              >{{ $t("title.brandroom.sole") }}
                            </p>
                            <p class="d-flex align-items-center">
                              <input
                                type="text"
                                class="text-truncate"
                                id="sole"
                                :placeholder="$t('title.brandroom.sole')"
                                :aria-label="$t('ttitle.brandroom.input_sole')"
                                v-model="fittingreqinfo.club_sol"
                                readonly
                              />
                              <label for="sole" class="ms-1">&deg;</label>
                            </p>
                          </div>
                        </div>
                        <div class="col">
                          <div class="d-flex flex-column">
                            <p class="mb-2">
                              <small class="rounded-circle bg-purple">4</small
                              >{{ $t("title.brandroom.loft") }}
                            </p>
                            <p class="d-flex align-items-center">
                              <input
                                type="text"
                                class="text-truncate"
                                id="loft"
                                :placeholder="$t('title.brandroom.loft')"
                                :aria-label="$t('title.brandroom.input_loft')"
                                v-model="fittingreqinfo.club_loft"
                                readonly
                              />
                              <label for="loft" class="ms-1">&deg;</label>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- //card-footer -->
                  </div>
                </div>

                <div class="col-md-4" v-if="fittingreqinfo.fit_club_type > 3">
                  <div class="card h-100">
                    <div class="card-body d-flex justify-content-center p-0">
                      <img
                        src="/img/fit_anls_iron_fv.png"
                        class="align-self-center img-fluid"
                        alt="클럽분석"
                      />
                    </div>
                    <!-- //card-body -->
                    <div
                      class="card-footer bg-white px-0 px-md-2 py-4 rounded-0 border-top"
                    >
                      <div class="row gx-2 gy-2 text-nowrap fs-14">
                        <div class="col">
                          <div class="d-flex flex-column">
                            <p class="mb-2">
                              <small class="rounded-circle bg-green">1</small
                              >{{ $t("title.brandroom.lie") }}
                            </p>
                            <p class="d-flex align-items-center">
                              <input
                                type="text"
                                class="text-truncate"
                                id="loft"
                                :placeholder="$t('title.brandroom.lie')"
                                :aria-label="$t('title.brandroom.input_lie')"
                                v-model="fittingreqinfo.club_lie"
                                readonly
                              />
                              <label for="loft" class="ms-1">&deg;</label>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- //card-footer -->
                  </div>
                </div>
                <!-- //클럽분석 : 아이언, 웨지 -->
              </div>
            </div>
          </section>
          <!-- //구질 및 클럽 분석  -->
          <div class="btn-bottom-wrapper">
            <b-button-group>
              <b-button
                @click="preViewTabIndex--"
                size="xl"
                variant="outline-secondary btn-prev"
                disabled
                aria-label="이전"
              >
                <span class="material-icons-outlined">arrow_back_ios</span>
              </b-button>
              <b-button
                @click="preViewTabIndex++"
                size="xl"
                variant="outline-secondary btn-next"
                aria-label="다음"
              >
                <span class="material-icons-outlined">arrow_forward_ios</span>
              </b-button>
            </b-button-group>
          </div>
        </div>

        <!-- TabIndex : 1, 원포인트레슨 -->
        <div
          class="tab-pane fade show"
          :class="{ active: preViewTabIndex == 1 }"
        >
          <section class="fitting-lesson">
            <h6 class="sub-title">
              {{ $t("title.brandroom.one_point_lesson") }}
            </h6>
            <div class="row g-0 table-type header-col">
              <div class="col-sm-5 col-md-4">
                <span>{{ "lesson1" | get_lesson_title }}</span>
              </div>
              <div class="col-sm-7 col-md-8">
                <b-form-textarea
                  class="mb-2"
                  :value="fittingreqinfo.lesson1"
                  plaintext
                ></b-form-textarea>

                <div class="rating-wrapper d-sm-inline-flex">
                  <label for="rating-address">{{
                    $t("title.brandroom.ratingbyclassificationmotion")
                  }}</label>
                  <b-form-rating
                    id="rating-address"
                    :value="fittingreqinfo.lessonlevel1"
                    readonly
                    no-border
                    show-value
                    show-value-max
                    class="py-1"
                  ></b-form-rating>
                </div>
              </div>

              <div class="col-sm-5 col-md-4">
                <span>{{ "lesson2" | get_lesson_title }}</span>
              </div>
              <div class="col-sm-7 col-md-8">
                <b-form-textarea
                  plaintext
                  class="mb-2"
                  :value="fittingreqinfo.lesson2"
                ></b-form-textarea>
                <div class="rating-wrapper d-sm-inline-flex">
                  <label for="rating-address">{{
                    $t("title.brandroom.ratingbyclassificationmotion")
                  }}</label>
                  <b-form-rating
                    id="rating-address"
                    :value="fittingreqinfo.lessonlevel2"
                    no-border
                    readonly
                    show-value
                    show-value-max
                    class="py-1"
                  ></b-form-rating>
                </div>
              </div>

              <div class="col-sm-5 col-md-4">
                <span>{{ "lesson3" | get_lesson_title }}</span>
              </div>
              <div class="col-sm-7 col-md-8">
                <b-form-textarea
                  plaintext
                  class="mb-2"
                  :value="fittingreqinfo.lesson3"
                ></b-form-textarea>
                <div class="rating-wrapper d-sm-inline-flex">
                  <label for="rating-address">{{
                    $t("title.brandroom.ratingbyclassificationmotion")
                  }}</label>
                  <b-form-rating
                    id="rating-address"
                    :value="fittingreqinfo.lessonlevel3"
                    no-border
                    readonly
                    show-value
                    show-value-max
                    class="py-1"
                  ></b-form-rating>
                </div>
              </div>

              <div class="col-sm-5 col-md-4">
                <span>{{ "lesson4" | get_lesson_title }}</span>
              </div>
              <div class="col-sm-7 col-md-8">
                <b-form-textarea
                  plaintext
                  class="mb-2"
                  :value="fittingreqinfo.lesson4"
                ></b-form-textarea>
                <div class="rating-wrapper d-sm-inline-flex">
                  <label for="rating-address">{{
                    $t("title.brandroom.ratingbyclassificationmotion")
                  }}</label>
                  <b-form-rating
                    id="rating-address"
                    :value="fittingreqinfo.lessonlevel4"
                    no-border
                    readonly
                    show-value
                    show-value-max
                    class="py-1"
                  ></b-form-rating>
                </div>
              </div>

              <div class="col-sm-5 col-md-4">
                <span>{{ "lesson5" | get_lesson_title }}</span>
              </div>
              <div class="col-sm-7 col-md-8">
                <b-form-textarea
                  plaintext
                  class="mb-2"
                  :value="fittingreqinfo.lesson5"
                ></b-form-textarea>
                <div class="rating-wrapper d-sm-inline-flex">
                  <label for="rating-address">{{
                    $t("title.brandroom.ratingbyclassificationmotion")
                  }}</label>
                  <b-form-rating
                    id="rating-address"
                    :value="fittingreqinfo.lessonlevel5"
                    no-border
                    readonly
                    show-value
                    show-value-max
                    class="py-1"
                  ></b-form-rating>
                </div>
              </div>

              <div class="col-sm-5 col-md-4">
                <span>{{ "lesson6" | get_lesson_title }}</span>
              </div>
              <div class="col-sm-7 col-md-8">
                <b-form-textarea
                  plaintext
                  class="mb-2"
                  :value="fittingreqinfo.lesson6"
                ></b-form-textarea>
                <div class="rating-wrapper d-sm-inline-flex">
                  <label for="rating-address">{{
                    $t("title.brandroom.ratingbyclassificationmotion")
                  }}</label>
                  <b-form-rating
                    id="rating-address"
                    :value="fittingreqinfo.lessonlevel6"
                    no-border
                    readonly
                    show-value
                    show-value-max
                    class="py-1"
                  ></b-form-rating>
                </div>
              </div>

              <div class="col-sm-5 col-md-4">
                <span>{{ "lesson7" | get_lesson_title }}</span>
              </div>
              <div class="col-sm-7 col-md-8">
                <b-form-textarea
                  plaintext
                  class="mb-2"
                  :value="fittingreqinfo.lesson7"
                ></b-form-textarea>
                <div class="rating-wrapper d-sm-inline-flex">
                  <label for="rating-address">{{
                    $t("title.brandroom.ratingbyclassificationmotion")
                  }}</label>
                  <b-form-rating
                    id="rating-address"
                    :value="fittingreqinfo.lessonlevel7"
                    no-border
                    readonly
                    show-value
                    show-value-max
                    class="py-1"
                  ></b-form-rating>
                </div>
              </div>

              <div class="col-sm-5 col-md-4 border-sm-0">
                <span>{{ "lessontotal" | get_lesson_title }}</span>
              </div>
              <div class="col-sm-7 col-md-8">
                <b-form-textarea
                  plaintext
                  :value="fittingreqinfo.lessontotal"
                ></b-form-textarea>
              </div>
            </div>
          </section>

          <div class="btn-bottom-wrapper">
            <b-button-group>
              <b-button
                @click="preViewTabIndex--"
                size="xl"
                variant="outline-secondary btn-prev"
                aria-label="이전"
              >
                <span class="material-icons-outlined">arrow_back_ios</span>
              </b-button>
              <b-button
                @click="preViewTabIndex++"
                size="xl"
                variant="outline-secondary btn-next"
                aria-label="다음"
              >
                <span class="material-icons-outlined">arrow_forward_ios</span>
              </b-button>
            </b-button-group>
          </div>
        </div>

        <!-- TabIndex : 2, 고급형 -->
        <div
          class="tab-pane fade show"
          :class="{ active: preViewTabIndex == 2 }"
        >
          <section>
            <h6 class="sub-title">
              <span class="brand-name fw-bold">{{
                form.p_info.fit_brand_nm
              }}</span
              >{{ $t("text.brandroom.recommended_by") }}
              <span class="text-green">{{
                $t("title.brandroom.permium")
              }}</span>
            </h6>
            <div class="card m-0 p-0 bg-transparent border-0 rounded-0">
              <div class="row g-0 table-type header-col">
                <div class="col-sm-3">
                  <div
                    class="d-flex flex-fill justify-content-center h-100 bg-white"
                  >
                    <img
                      :src="form.p_info.goodsinfo.fit_goods_image1 | get_img"
                      class="img-fluid rounded-0"
                    />
                  </div>
                </div>
                <div class="col-sm-9 d-flex flex-column align-items-stretch">
                  <div class="card-body px-0 px-sm-3">
                    <h4 class="card-title">
                      {{ form.p_info.goodsinfo.fit_goods_nm }}
                    </h4>
                    <div class="row g-0 row-cols-1 row-cols-sm-2">
                      <div
                        class="col-sm-4 mt-2 mt-sm-0 py-0 py-sm-2 fs-6 fw-bold text-black"
                      >
                        {{ $t("title.brandroom.price") }}
                      </div>
                      <div class="col-sm-8 py-0 py-sm-2">
                        <h5 class="text-price">
                          &#8361;
                          {{ form.p_info.fit_sale_price | comma }}
                        </h5>
                      </div>

                      <div
                        class="col-sm-4 mt-2 mt-sm-0 py-0 py-sm-2 border-top-sm fs-6 fw-bold text-black"
                      >
                        {{ $t("title.brandroom.shop_price") }}
                      </div>
                      <div class="col-sm-8 py-0 py-sm-2 border-top-sm">
                        <h5 class="text-price">
                          &#8361;
                          {{ form.p_info.fit_shop_price | comma }}
                        </h5>
                      </div>

                      <div
                        class="col-sm-4 mt-3 mt-sm-0 py-0 py-sm-2 border-top-sm fs-6 fw-bold text-black"
                      >
                        {{ $t("title.brandroom.benefit") }}
                      </div>
                      <div class="col-sm-8 py-0 py-sm-2 border-top-sm fs-6">
                        {{ form.p_info.goodsinfo.fit_goods_info }}
                        <!-- 미등록 -->
                      </div>
                    </div>
                  </div>
                  <!-- //card-body -->
                  <div
                    class="card-footer px-0 px-sm-3 py-0 bg-transparent border-0 rounded-0"
                  >
                    <div class="btn-bottom-wrapper mt-2 mb-4 mt-sm-0 mb-sm-3">
                      <!-- <b-button
                        size="md"
                        variant="primary"
                        aria-label="제품구매"
                      >
                        제품구매
                      </b-button> -->
                    </div>
                  </div>
                  <!-- //card-footer -->
                </div>
              </div>
            </div>
          </section>
          <!-- //기본 정보 등록 -->
          <section>
            <h6 class="sub-title">{{ $t("title.brandroom.goods_detail") }}</h6>
            <div class="row g-0 table-type header-col">
              <img
                v-if="form.p_info.goodsinfo.fit_goods_image2"
                :src="form.p_info.goodsinfo.fit_goods_image2 | get_img"
                class="img-fluid rounded-0"
              />
              <img
                v-if="form.p_info.goodsinfo.fit_goods_image3"
                :src="form.p_info.goodsinfo.fit_goods_image3 | get_img"
                class="img-fluid rounded-0"
              />
            </div>
          </section>
          <section class="reg-spec">
            <h6 class="sub-title">{{ $t("title.brandroom.club_spec") }}</h6>
            <b-table-simple responsive table-class="border-0">
              <b-thead>
                <b-tr>
                  <b-th sticky-column>{{
                    $t("title.brandroom.club_type")
                  }}</b-th>
                  <b-th
                    v-for="(val, idx) in form.p_info.ansclublist"
                    :key="'p_clubnotype' + idx"
                  >
                    {{
                      fittingreqinfo.clubtypelist.find(
                        (v) => v.clubtype_code == val.fit_club_nm
                      ).clubtype_code_name
                    }}
                  </b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-th sticky-column
                    >{{ $t("title.brandroom.loft") }}(&deg;)</b-th
                  >
                  <b-td
                    v-for="(val, idx) in form.p_info.ansclublist"
                    :key="'p_clubloft' + idx"
                  >
                    {{ val.fit_club_loft }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th sticky-column
                    >{{ $t("title.brandroom.lie") }}(&deg;)</b-th
                  >
                  <b-td
                    v-for="(val, idx) in form.p_info.ansclublist"
                    :key="'p_clublie' + idx"
                  >
                    {{ val.fit_club_lie }}
                  </b-td>
                </b-tr>

                <b-tr v-if="form.p_info.fit_club_type < 4">
                  <b-th sticky-column>{{
                    $t("title.brandroom.headvolume")
                  }}</b-th>
                  <b-td
                    v-for="(val, idx) in form.p_info.ansclublist"
                    :key="'p_clubheadvolume' + idx"
                  >
                    {{ val.fit_club_headvolume }}
                  </b-td>
                </b-tr>
                <b-tr v-if="form.p_info.fit_club_type > 3">
                  <b-th sticky-column
                    >{{ $t("title.brandroom.sole") }}(&deg;)</b-th
                  >
                  <b-td
                    v-for="(val, idx) in form.p_info.ansclublist"
                    :key="'p_clubsole' + idx"
                  >
                    {{ val.fit_club_sol }}
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th sticky-column>{{ $t("title.brandroom.fp") }}</b-th>
                  <b-td
                    v-for="(val, idx) in form.p_info.ansclublist"
                    :key="'p_clubfp' + idx"
                    >{{ val.fit_club_fp }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th sticky-column>{{ $t("title.brandroom.length") }}</b-th>
                  <b-td
                    v-for="(val, idx) in form.p_info.ansclublist"
                    :key="'p_clublength' + idx"
                  >
                    {{ val.fit_club_length }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th sticky-column rowspan="5">
                    <div class="sticky-column-rowspan">
                      <div>{{ $t("title.brandroom.balance") }}</div>
                      <div class="flex-column">
                        <div
                          v-if="
                            form.p_info.fit_balance1 ==
                            form.p_info.fit_goods_balance
                          "
                        >
                          {{ form.p_info.fit_balance1 | get_balance }}
                        </div>
                        <div
                          v-if="
                            form.p_info.fit_balance2 ==
                            form.p_info.fit_goods_balance
                          "
                        >
                          {{ form.p_info.fit_balance2 | get_balance }}
                        </div>
                        <div
                          v-if="
                            form.p_info.fit_balance3 ==
                            form.p_info.fit_goods_balance
                          "
                        >
                          {{ form.p_info.fit_balance3 | get_balance }}
                        </div>
                        <div
                          v-if="
                            form.p_info.fit_balance4 ==
                            form.p_info.fit_goods_balance
                          "
                        >
                          {{ form.p_info.fit_balance4 | get_balance }}
                        </div>
                        <div
                          class="py-2 pe-2"
                          v-if="
                            form.p_info.fit_balance5 ==
                            form.p_info.fit_goods_balance
                          "
                        >
                          {{ form.p_info.fit_balance5 | get_balance }}
                        </div>
                      </div>
                    </div>
                  </b-th>
                  <template v-for="(val, idx) in form.p_info.ansclublist">
                    <b-td
                      :key="'p_clubflextitle1' + idx"
                      v-if="
                        form.p_info.fit_balance1 ==
                        form.p_info.fit_goods_balance
                      "
                    >
                      {{ val.fit_club_balance1 }}
                    </b-td>
                  </template>
                </b-tr>
                <b-tr>
                  <template v-for="(val, idx) in form.p_info.ansclublist">
                    <b-td
                      :key="'p_clubflextitle2' + idx"
                      v-if="
                        form.p_info.fit_balance2 ==
                        form.p_info.fit_goods_balance
                      "
                    >
                      {{ val.fit_club_balance2 }}
                    </b-td>
                  </template>
                </b-tr>
                <b-tr>
                  <template v-for="(val, idx) in form.p_info.ansclublist">
                    <b-td
                      :key="'p_clubflextitle3' + idx"
                      v-if="
                        form.p_info.fit_balance3 ==
                        form.p_info.fit_goods_balance
                      "
                    >
                      {{ val.fit_club_balance3 }}
                    </b-td>
                  </template>
                </b-tr>
                <b-tr>
                  <template v-for="(val, idx) in form.p_info.ansclublist">
                    <b-td
                      :key="'p_clubflextitle4' + idx"
                      v-if="
                        form.p_info.fit_balance4 ==
                        form.p_info.fit_goods_balance
                      "
                    >
                      {{ val.fit_club_balance4 }}
                    </b-td>
                  </template>
                </b-tr>
                <b-tr>
                  <template v-for="(val, idx) in form.p_info.ansclublist">
                    <b-td
                      :key="'p_clubflextitle5' + idx"
                      v-if="
                        form.p_info.fit_balance5 ==
                        form.p_info.fit_goods_balance
                      "
                    >
                      {{ val.fit_club_balance5 }}
                    </b-td>
                  </template>
                </b-tr>
                <b-tr>
                  <b-th sticky-column class="border-0">{{
                    $t("title.brandroom.totalweightgram")
                  }}</b-th>
                  <b-td
                    v-for="(val, idx) in form.p_info.ansclublist"
                    :key="'p_clubweight' + idx"
                  >
                    {{ val.fit_club_weight }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </section>
          <!-- 스펙 등록 -->

          <section class="reg-etc">
            <div class="row gx-4 gy-5 border-0">
              <div class="col-lg-6 d-flex flex-column">
                <h6 class="sub-title">{{ $t("title.brandroom.shaft") }}</h6>
                <div class="card h-100">
                  <div class="card-body p-0">
                    <p class="card-title">
                      {{ form.p_info.shaftinfo.fit_goods_shaft_nm }}
                      /
                      {{
                        form.p_info.shaftinfo.fit_shaft_material
                          | get_shaft_material
                      }}
                    </p>
                    <img
                      :src="
                        form.p_info.shaftinfo.fit_goods_shaft_image1 | get_img
                      "
                      class="card-img-top rounded-0"
                      alt="샤트프"
                    />
                  </div>
                  <div class="card-footer">
                    <table class="table table-sm table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">
                            {{ $t("title.brandroom.strength") }}
                          </th>
                          <th scope="col">
                            {{ $t("title.brandroom.weight") }}
                          </th>
                          <th scope="col">
                            {{ $t("title.brandroom.torque") }}
                          </th>
                          <th scope="col">
                            {{ $t("title.brandroom.kickpoint") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {{
                              form.p_info.shaftinfo.fit_goods_shaft_balance
                                | get_balance
                            }}
                          </td>
                          <td>
                            {{ form.p_info.shaftinfo.fit_goods_shaft_weight }}
                          </td>
                          <td>
                            {{ form.p_info.shaftinfo.fit_goods_shaft_torque }}
                          </td>
                          <td>
                            {{
                              form.p_info.shaftinfo.fit_goods_shaft_kickpoint
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 d-flex flex-column">
                <h6 class="sub-title">{{ $t("title.brandroom.grip") }}</h6>
                <div class="card h-100">
                  <div class="card-body p-0">
                    <p class="card-title">
                      {{ form.p_info.gripinfo.fit_goods_grip_nm }}}
                    </p>
                    <img
                      :src="
                        form.p_info.gripinfo.fit_goods_grip_image1 | get_img
                      "
                      class="card-img-top rounded-0"
                      alt="그립"
                    />
                  </div>
                  <div class="card-footer">
                    <table class="table table-sm table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">
                            {{ $t("title.brandroom.standard") }}
                          </th>
                          <th scope="col">
                            {{ $t("title.brandroom.weight") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {{ form.p_info.gripinfo.fit_goods_grip_standard }}
                          </td>
                          <td>
                            {{ form.p_info.gripinfo.fit_goods_grip_weight }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- 샤프트 & 그립 등록 -->

          <div class="btn-bottom-wrapper">
            <b-button-group>
              <b-button
                @click="preViewTabIndex--"
                size="xl"
                variant="outline-secondary btn-prev"
                aria-label="이전"
              >
                <span class="material-icons-outlined">arrow_back_ios</span>
              </b-button>
              <b-button
                @click="preViewTabIndex++"
                size="xl"
                variant="outline-secondary btn-next"
                aria-label="다음"
              >
                <span class="material-icons-outlined">arrow_forward_ios</span>
              </b-button>
            </b-button-group>
          </div>
        </div>

        <!-- TabIndex : 3, 보급형 -->
        <div
          class="tab-pane fade show"
          :class="{ active: preViewTabIndex == 3 }"
        >
          <section>
            <h6 class="sub-title">
              <span class="brand-name fw-bold">{{
                form.c_info.fit_brand_nm
              }}</span
              >{{ $t("text.brandroom.recommended_by") }}
              <span class="text-green">{{ $t("title.brandroom.entry") }}</span>
            </h6>
            <div class="card m-0 p-0 bg-transparent border-0 rounded-0">
              <div class="row g-0 table-type header-col">
                <div class="col-sm-3">
                  <div
                    class="d-flex flex-fill justify-content-center h-100 bg-white"
                  >
                    <img
                      :src="form.c_info.goodsinfo.fit_goods_image1 | get_img"
                      class="img-fluid rounded-0"
                    />
                  </div>
                </div>
                <div class="col-sm-9 d-flex flex-column align-items-stretch">
                  <div class="card-body px-0 px-sm-3">
                    <h4 class="card-title">
                      {{ form.c_info.goodsinfo.fit_goods_nm }}
                    </h4>
                    <div class="row g-0 row-cols-1 row-cols-sm-2">
                      <div
                        class="col-sm-4 mt-2 mt-sm-0 py-0 py-sm-2 fs-6 fw-bold text-black"
                      >
                        {{ $t("title.brandroom.price") }}
                      </div>
                      <div class="col-sm-8 py-0 py-sm-2">
                        <h5 class="text-price">
                          &#8361;
                          {{ form.c_info.fit_sale_price | comma }}
                        </h5>
                      </div>

                      <div
                        class="col-sm-4 mt-2 mt-sm-0 py-0 py-sm-2 border-top-sm fs-6 fw-bold text-black"
                      >
                        {{ $t("title.brandroom.shop_price") }}
                      </div>
                      <div class="col-sm-8 py-0 py-sm-2 border-top-sm">
                        <h5 class="text-price">
                          &#8361;
                          {{ form.c_info.fit_shop_price | comma }}
                        </h5>
                      </div>

                      <div
                        class="col-sm-4 mt-3 mt-sm-0 py-0 py-sm-2 border-top-sm fs-6 fw-bold text-black"
                      >
                        {{ $t("title.brandroom.benefit") }}
                      </div>
                      <div class="col-sm-8 py-0 py-sm-2 border-top-sm fs-6">
                        {{ form.c_info.goodsinfo.fit_goods_info }}
                        <!-- 미등록 -->
                      </div>
                    </div>
                  </div>
                  <!-- //card-body -->
                  <div
                    class="card-footer px-0 px-sm-3 py-0 bg-transparent border-0 rounded-0"
                  >
                    <div class="btn-bottom-wrapper mt-2 mb-4 mt-sm-0 mb-sm-3">
                      <!-- <b-button
                        size="md"
                        variant="primary"
                        aria-label="제품구매"
                      >
                        제품구매
                      </b-button> -->
                    </div>
                  </div>
                  <!-- //card-footer -->
                </div>
              </div>
            </div>
          </section>
          <!-- //기본 정보 등록 -->
          <section>
            <h6 class="sub-title">{{ $t("title.brandroom.goods_detail") }}</h6>
            <div class="row g-0 table-type header-col">
              <img
                v-if="form.c_info.goodsinfo.fit_goods_image2"
                :src="form.c_info.goodsinfo.fit_goods_image2 | get_img"
                class="img-fluid rounded-0"
              />
              <img
                v-if="form.c_info.goodsinfo.fit_goods_image3"
                :src="form.c_info.goodsinfo.fit_goods_image3 | get_img"
                class="img-fluid rounded-0"
              />
            </div>
          </section>
          <section class="reg-spec">
            <h6 class="sub-title">{{ $t("title.brandroom.club_spec") }}</h6>
            <b-table-simple responsive table-class="border-0">
              <b-thead>
                <b-tr>
                  <b-th sticky-column>{{ $t("Club Infromation") }}</b-th>
                  <b-th
                    v-for="(val, idx) in form.c_info.ansclublist"
                    :key="'p_clubnotype' + idx"
                  >
                    {{
                      fittingreqinfo.clubtypelist.find(
                        (v) => v.clubtype_code == val.fit_club_nm
                      ).clubtype_code_name
                    }}
                  </b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-th sticky-column
                    >{{ $t("title.brandroom.loft") }}(&deg;)</b-th
                  >
                  <b-td
                    v-for="(val, idx) in form.c_info.ansclublist"
                    :key="'p_clubloft' + idx"
                  >
                    {{ val.fit_club_loft }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th sticky-column
                    >{{ $t("title.brandroom.lie") }}(&deg;)</b-th
                  >
                  <b-td
                    v-for="(val, idx) in form.c_info.ansclublist"
                    :key="'p_clublie' + idx"
                  >
                    {{ val.fit_club_lie }}
                  </b-td>
                </b-tr>
                <b-tr v-if="form.c_info.fit_club_type < 4">
                  <b-th sticky-column>{{
                    $t("title.brandroom.headvolume")
                  }}</b-th>
                  <b-td
                    v-for="(val, idx) in form.c_info.ansclublist"
                    :key="'c_clubheadvolume' + idx"
                  >
                    {{ val.fit_club_headvolume }}
                  </b-td>
                </b-tr>
                <b-tr v-if="form.c_info.fit_club_type > 3">
                  <b-th sticky-column
                    >{{ $t("title.brandroom.sole") }}(&deg;)</b-th
                  >
                  <b-td
                    v-for="(val, idx) in form.c_info.ansclublist"
                    :key="'c_clubsole' + idx"
                  >
                    {{ val.fit_club_sol }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th sticky-column>{{ $t("title.brandroom.fp") }}</b-th>
                  <b-td
                    v-for="(val, idx) in form.c_info.ansclublist"
                    :key="'p_clubfp' + idx"
                    >{{ val.fit_club_fp }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th sticky-column>{{ $t("title.brandroom.length") }}</b-th>
                  <b-td
                    v-for="(val, idx) in form.c_info.ansclublist"
                    :key="'p_clublength' + idx"
                  >
                    {{ val.fit_club_length }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th sticky-column rowspan="5">
                    <div class="sticky-column-rowspan">
                      <div>{{ $t("title.brandroom.balance") }}</div>
                      <div class="flex-column">
                        <div
                          v-if="
                            form.c_info.fit_balance1 ==
                            form.c_info.fit_goods_balance
                          "
                        >
                          {{ form.c_info.fit_balance1 | get_balance }}
                        </div>
                        <div
                          v-if="
                            form.c_info.fit_balance2 ==
                            form.c_info.fit_goods_balance
                          "
                        >
                          {{ form.c_info.fit_balance2 | get_balance }}
                        </div>
                        <div
                          v-if="
                            form.c_info.fit_balance3 ==
                            form.c_info.fit_goods_balance
                          "
                        >
                          {{ form.c_info.fit_balance3 | get_balance }}
                        </div>
                        <div
                          v-if="
                            form.c_info.fit_balance4 ==
                            form.c_info.fit_goods_balance
                          "
                        >
                          {{ form.c_info.fit_balance4 | get_balance }}
                        </div>
                        <div
                          class="py-2 pe-2"
                          v-if="
                            form.c_info.fit_balance5 ==
                            form.c_info.fit_goods_balance
                          "
                        >
                          {{ form.c_info.fit_balance5 | get_balance }}
                        </div>
                      </div>
                    </div>
                  </b-th>
                  <template v-for="(val, idx) in form.c_info.ansclublist">
                    <b-td
                      :key="'p_clubflextitle1' + idx"
                      v-if="
                        form.c_info.fit_balance1 ==
                        form.c_info.fit_goods_balance
                      "
                    >
                      {{ val.fit_club_balance1 }}
                    </b-td>
                  </template>
                </b-tr>
                <b-tr>
                  <template v-for="(val, idx) in form.c_info.ansclublist">
                    <b-td
                      :key="'p_clubflextitle2' + idx"
                      v-if="
                        form.c_info.fit_balance2 ==
                        form.c_info.fit_goods_balance
                      "
                    >
                      {{ val.fit_club_balance2 }}
                    </b-td>
                  </template>
                </b-tr>
                <b-tr>
                  <template v-for="(val, idx) in form.c_info.ansclublist">
                    <b-td
                      :key="'p_clubflextitle3' + idx"
                      v-if="
                        form.c_info.fit_balance3 ==
                        form.c_info.fit_goods_balance
                      "
                    >
                      {{ val.fit_club_balance3 }}
                    </b-td>
                  </template>
                </b-tr>
                <b-tr>
                  <template v-for="(val, idx) in form.c_info.ansclublist">
                    <b-td
                      :key="'p_clubflextitle4' + idx"
                      v-if="
                        form.c_info.fit_balance4 ==
                        form.c_info.fit_goods_balance
                      "
                    >
                      {{ val.fit_club_balance4 }}
                    </b-td>
                  </template>
                </b-tr>
                <b-tr>
                  <template v-for="(val, idx) in form.c_info.ansclublist">
                    <b-td
                      :key="'p_clubflextitle5' + idx"
                      v-if="
                        form.c_info.fit_balance5 ==
                        form.c_info.fit_goods_balance
                      "
                    >
                      {{ val.fit_club_balance5 }}
                    </b-td>
                  </template>
                </b-tr>
                <b-tr>
                  <b-th sticky-column class="border-0">{{
                    $t("title.brandroom.totalweightgram")
                  }}</b-th>
                  <b-td
                    v-for="(val, idx) in form.c_info.ansclublist"
                    :key="'p_clubweight' + idx"
                  >
                    {{ val.fit_club_weight }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </section>
          <!-- 스펙 등록 -->

          <section class="reg-etc">
            <div class="row gx-4 gy-5 border-0">
              <div class="col-lg-6 d-flex flex-column">
                <h6 class="sub-title">{{ $t("title.brandroom.shaft") }}</h6>
                <div class="card h-100">
                  <div class="card-body p-0">
                    <p class="card-title">
                      {{ form.c_info.shaftinfo.fit_goods_shaft_nm }}
                      /
                      {{
                        form.c_info.shaftinfo.fit_shaft_material
                          | get_shaft_material
                      }}
                    </p>
                    <img
                      :src="
                        form.c_info.shaftinfo.fit_goods_shaft_image1 | get_img
                      "
                      class="card-img-top rounded-0"
                      alt="샤트프"
                    />
                  </div>
                  <div class="card-footer">
                    <table class="table table-sm table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">
                            {{ $t("title.brandroom.strength") }}
                          </th>
                          <th scope="col">
                            {{ $t("title.brandroom.weight") }}
                          </th>
                          <th scope="col">
                            {{ $t("title.brandroom.torque") }}
                          </th>
                          <th scope="col">
                            {{ $t("title.brandroom.kickpoint") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {{
                              form.c_info.shaftinfo.fit_goods_shaft_balance
                                | get_balance
                            }}
                          </td>
                          <td>
                            {{ form.c_info.shaftinfo.fit_goods_shaft_weight }}
                          </td>
                          <td>
                            {{ form.c_info.shaftinfo.fit_goods_shaft_torque }}
                          </td>
                          <td>
                            {{
                              form.c_info.shaftinfo.fit_goods_shaft_kickpoint
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 d-flex flex-column">
                <h6 class="sub-title">{{ $t("title.brandroom.grip") }}</h6>
                <div class="card h-100">
                  <div class="card-body p-0">
                    <p class="card-title">
                      {{ form.c_info.gripinfo.fit_goods_grip_nm }}}
                    </p>
                    <img
                      :src="
                        form.c_info.gripinfo.fit_goods_grip_image1 | get_img
                      "
                      class="card-img-top rounded-0"
                      alt="그립"
                    />
                  </div>
                  <div class="card-footer">
                    <table class="table table-sm table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">
                            {{ $t("title.brandroom.standard") }}
                          </th>
                          <th scope="col">
                            {{ $t("title.brandroom.weight") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {{ form.c_info.gripinfo.fit_goods_grip_standard }}
                          </td>
                          <td>
                            {{ form.c_info.gripinfo.fit_goods_grip_weight }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- 샤프트 & 그립 등록 -->

          <div class="btn-bottom-wrapper">
            <b-button-group>
              <b-button
                @click="preViewTabIndex--"
                size="xl"
                variant="outline-secondary btn-prev"
                aria-label="이전"
              >
                <span class="material-icons-outlined">arrow_back_ios</span>
              </b-button>
              <b-button
                @click="preViewTabIndex++"
                size="xl"
                variant="outline-secondary btn-next"
                disabled
                aria-label="다음"
              >
                <span class="material-icons-outlined">arrow_forward_ios</span>
              </b-button>
            </b-button-group>
          </div>
        </div>

        <div class="btn-bottom-wrapper">
          <b-button
            size="xl"
            variant="outline-primary"
            aria-label="목록"
            @click="
              $router.push({
                name: 'FittingList',
                query: { goodstype: goodstype },
              })
            "
            >{{ $t("button.brandroom.list") }}</b-button
          >
        </div>
      </div>
      <!-- //tab-content -->
    </div>
  </div>
</template>

<script>
import locations from "@/components/Location";
import ax from "@/api/fitting";
import "@/filter/common";
import "swiper/css/swiper.css";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { Radar } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  RadialLinearScale,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  RadialLinearScale,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");

export default {
  name: "FittingAnswerView",
  components: {
    locations,
    Radar,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      form: {
        impactgrade: "1",
        distancegrade: "1",
        directiongrade: "1",
        accuracygrade: "1",
        positiongrade: "1",

        p_info: {
          goodsinfo: {},
          memberinfo: {},
          answerinfo: [],
          gripinfo: {},
          shaftinfo: {},
        },
        c_info: {
          goodsinfo: {},
          memberinfo: {},
          answerinfo: [],
          gripinfo: {},
          shaftinfo: {},
        },
      },

      fitreqno: this.$route.params.fitreqno,

      fittingreqinfo: {
        adinfo: {
          ad_img1_info: {},
          ad_img2_info: {},
          ad_img3_info: {},
          ad_mov_info: {},
          ad_title_info: {},
        },

        clubtypelist: [],
      },
      preViewTabIndex: 0,

      radaroptions: {
        scale: {
          r: {
            min: 0, // MIN
            max: 5, // MAX
            beginAtZero: true,
            angleLines: {
              display: true,
              // color: 'red',
            },
            grid: {
              circular: true,
            },
          },
          ticks: {
            stepSize: 1,
          },
        },
        plugins: {
          legend: {
            display: false,
          },
        },
        responsive: true,
        maintainAspectRatio: true,
      },
      resultradardata: {
        labels: [
          this.$i18n.t("title.common.distance"),
          this.$i18n.t("title.brandroom.direction"),
          this.$i18n.t("title.brandroom.accuracy"),
          this.$i18n.t("title.brandroom.posture"),
          this.$i18n.t("title.brandroom.Impact"),
        ],
        datasets: [
          {
            label: "My First dataset",
            backgroundColor: "rgba(179,181,198,0.2)",
            borderColor: "rgba(179,181,198,1)",
            pointBackgroundColor: "rgba(179,181,198,1)",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "rgba(179,181,198,1)",
            data: [],
          },
        ],
      },
      watching: true,
    };
  },

  created() {
    this.get_fittinganswerview().then((res) => {
      this.watching = res;
      this.resultradardata.datasets[0].data = [
        this.form.distancegrade,
        this.form.directiongrade,
        this.form.accuracygrade,
        this.form.positiongrade,
        this.form.impactgrade,
      ];
    });
  },

  methods: {
    get_fittinganswerview() {
      return new Promise((resolve, reject) => {
        ax.get_fittinganswerview(this.fitreqno, (flag, data) => {
          if (flag) {
            this.fittingreqinfo = data.fittingreqinfo;

            this.form.resulttxt = this.fittingreqinfo.fit_ans_txt;
            this.form._resultfilename = this.fittingreqinfo.fit_ans_file;
            this.form.impactgrade = this.fittingreqinfo.grade_impact;

            this.form.distancegrade = this.fittingreqinfo.grade_distance;
            this.form.directiongrade = this.fittingreqinfo.grade_direction;
            this.form.accuracygrade = this.fittingreqinfo.grade_accuracy;
            this.form.positiongrade = this.fittingreqinfo.grade_position;

            this.fittingreqinfo.answerinfo.forEach((val) => {
              if (val.fit_goods_grade === "P") {
                this.form.p_info = val;
              }
              if (val.fit_goods_grade === "C") {
                this.form.c_info = val;
              }
            });
            console.log(
              "🚀 ~ file: FittingAnswerView.vue:1630 ~ this.fittingreqinfo.answerinfo.forEach ~ this.form.p_info",
              this.form.p_info
            );
            console.log(
              "🚀 ~ file: FittingAnswerView.vue:1634 ~ this.fittingreqinfo.answerinfo.forEach ~ this.form.c_info",
              this.form.c_info
            );
            resolve(true);
          } else {
            reject(false);
            alert(data.message);
          }
        });
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    print() {
      window.print();
    },
  },
  watch: {},
};
</script>
